import React, { useState, useEffect } from 'react';
import { SearchResult } from '../SearchResult/SearchResult';
import { Wrapper, Container, Text } from './styled';
import { dataListAgencies } from './dataAgencies';
import { PredictiveInput } from '@app/src/common/PredictiveInput';
import { data } from './dataUbigeo';

interface Props {
  handleChangeInput?: Function;
}

export const SearchForm: React.FC<Props> = () => {

  const [value, setValue] = useState('');
  const [dataFiltered, setDataFiltered] = useState(dataListAgencies);

  useEffect(() => {
    setDataFiltered(
      dataListAgencies
        .filter(agency => agency.alias === value)
    )
  }, [value]);

  const handleClickClose = () => {
    if (dataFiltered.length > 0 && dataFiltered.length !== dataListAgencies.length) {
      setDataFiltered(dataListAgencies);
    }
  }

  return (
    <React.Fragment>
      <Wrapper>
        <Container>
          <Text>Encuentra la agencia más cercana en donde publicar tu aviso impreso</Text>
          <PredictiveInput
            dataList={data}
            handleChange={value => setValue(value.alias)}
            handleClickClose={handleClickClose}
          />
        </Container>
      </Wrapper>
      <SearchResult list={dataFiltered.length ? dataFiltered : dataListAgencies} />
    </React.Fragment>
)};
